import {createI18n} from 'vue-i18n'

export function loadLocaleMessages () {
	const locales = import.meta.glob('./../locales/*.json', {eager: true})
	const messages = {}
	Object.keys(locales).forEach(key => {
		const matched = key.match(/([A-Za-z0-9-_]+)\./i)
		if (matched && matched.length > 1) {
			const locale = matched[1]
			messages[locale] = locales[key];
		}
	})
	return messages
}

export default createI18n({
	locale: 'en',
	fallbackLocale: 'en',
	allowComposition: true,
	messages: loadLocaleMessages(),
	globalInjection: true,
	legacy: false
});